import { Location } from '../../../types/models/Location.model'
import { isObject } from '../../../utils/checks'

export const getLocationPartsTitles = (location: Location): string[] => {
  if (!isObject(location)) {
    return []
  }

  const locationPartsTitle = (
    location.address_parts ||
    location.location_address_parts ||
    []
  ).map((part) => part.title) as string[]

  //need to use 'as string[]' to avoid TS error since we are filtering falsy values and TS can't infer the type
  return [location.title].concat(locationPartsTitle).filter(Boolean)
}
